var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.file.categoria
          ? "Responder Expediente " +
            _vm.file.categoria +
            "-" +
            _vm.file.numeroExt
          : "Responder Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "form",
        {
          attrs: { autocomplete: "off", "data-vv-scope": "answerForm" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
            }
          }
        },
        [
          _c("div", [
            _vm._v(
              " Si decides responder este expediente vas a ser re-dirigido a un formulario y éste expediente quedará referenciado. "
            )
          ]),
          _c("div", { staticClass: "mt-3" }, [
            _c("div", { staticClass: "bg-alert p-3" }, [
              _vm._v(
                " Por favor selecciona con que tipo de expediente quieres responder, recuerda que "
              ),
              _c("b", [
                _vm._v("trámite interno es procesado por oficinas internas")
              ])
            ]),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c(
                  "vs-select",
                  {
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "Tipo de Expediente respuesta",
                      name: "formatDocument"
                    },
                    model: {
                      value: _vm.fileType,
                      callback: function($$v) {
                        _vm.fileType = $$v
                      },
                      expression: "fileType"
                    }
                  },
                  [
                    _c("vs-select-item", {
                      attrs: { value: "numInt", text: "Numeración interna" }
                    }),
                    _c("vs-select-item", {
                      attrs: { value: "numOf", text: "Numeración Of. Partes" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("list-user-groups", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.userGroupsState.list.length > 0 },
                      expression:
                        "{ required: userGroupsState.list.length > 0 }"
                    }
                  ],
                  ref: "creatorGroup",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    "only-groups": "",
                    label: "Grupo al que irá asociado el expediente",
                    name: "creatorGroup",
                    danger: _vm.errors.has("answerForm.creatorGroup"),
                    "danger-text": _vm.errors.first("answerForm.creatorGroup")
                  },
                  model: {
                    value: _vm.creatorGroup,
                    callback: function($$v) {
                      _vm.creatorGroup = $$v
                    },
                    expression: "creatorGroup"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "m-top-20",
              staticStyle: { display: "flex", "justify-content": "flex-end" }
            },
            [
              _c(
                "vs-button",
                {
                  attrs: { color: "dark", type: "border" },
                  on: {
                    click: function($event) {
                      return _vm.cancelAsign()
                    }
                  }
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "vs-button",
                {
                  staticStyle: { "margin-left": "12px" },
                  attrs: { color: "primary", type: "border" },
                  on: {
                    click: function($event) {
                      return _vm.attemptAnswerFile()
                    }
                  }
                },
                [_vm._v(" Si, Responder ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }